import styles from '../InterpretiveReportPage.module.css';

type SectionHeadProps = {
  number: string;
  eyebrow: string;
  title: string;
  intro: string;
};

/** Each section of the report starts on a new page, with its number and name above the title */
export const SectionHead = ({ number, eyebrow, title, intro }: SectionHeadProps) => (
  <div className={styles.sectionHead}>
    <span className={styles.eyebrow}>
      <span className={styles.number}>{number}</span>
      <span>{eyebrow}</span>
    </span>
    <h2 className={styles.sectionTitle}>{title}</h2>
    <p className={styles.sectionIntro}>{intro}</p>
  </div>
);
